import { useEffect } from 'react';
import SubscribeFunnel from '../components/SubscribeFunnel';
import { useNavigate } from 'react-router-dom';

export default function SubscribePage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'PetsBox - Abonează-te acum!';
  }, []);

  return (
    <SubscribeFunnel
      isOpen={true}
      onClose={() => navigate('/')}
    />
  );
}
